import { safeJsonParse } from "./json-parser";
import { logger } from "./logger";

export function setStorageItem(key: string, value: string): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.setItem(key, value);
  } catch (error) {
    logger({
      message: "Error setting item in localStorage",
      error: error as Error,
    });
  }
}

export function getStorageItem<T extends string>(key: string): T | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return localStorage.getItem(key) as T;
  } catch (error) {
    logger({
      message: "Error getting item from localStorage",
      error: error as Error,
    });

    return null;
  }
}

export function removeStorageItem(key: string): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.removeItem(key);
  } catch (error) {
    logger({
      message: "Error removing item from localStorage",
      error: error as Error,
    });
  }
}

export function setStorageJSON<T>(key: string, value: T): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    const jsonString = JSON.stringify(value);
    localStorage.setItem(key, jsonString);
  } catch (error) {
    logger({
      message: "Error setting item in localStorage",
      error: error as Error,
    });
  }
}

export function getStorageJSON<T>(key: string): T | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const jsonString = localStorage.getItem(key);
    return jsonString ? safeJsonParse<T>(jsonString) : null;
  } catch (error) {
    logger({
      message: "Error getting item from localStorage",
      error: error as Error,
    });

    return null;
  }
}

export function parseJSON<T>(jsonString: string): T | null {
  try {
    return JSON.parse(jsonString) as T;
  } catch (error) {
    console.error("Error parsing JSON string:", error);
    return null;
  }
}
